import { API_SP_RESEARCH_ROLES } from "globals/constants";
import { buildSearchParams, put, request } from "utils/proxy";

/**
 * Research Team Role Data Object
 *
 * @typedef {Object} ResearchRole
 *
 * @property {string} name - The name of the funding program round.
 * @property {string} researchRoleId - The ID of the research-team role.
 * @property {string} tenantId - The ID of the tenant.
 * @property {number | null} position - The index of the role in the list.
 * @property {boolean} active - The status of the role.
 */

export const researchRoles = {
	/**
	 * Retrieves a list of research-team roles.
	 *
	 * @param {object} [params] - Query parameters for filtering and pagination.
	 * @param {number} [params.page] - The page number for pagination.
	 * @param {number} [params.size] - The number of items per page.
	 *
	 * @returns {Promise<{ content: ResearchRole[]; totalElements: number; }>} A Promise that resolves with the list of research-team roles.
	 */
	findAll: (params = { size: 100 }) => request(API_SP_RESEARCH_ROLES + buildSearchParams(params)),

	/**
	 * Retrieves a research-team role by ID.
	 *
	 * @param id
	 * @return {Promise<ResearchRole>}
	 */
	findById: id => request(API_SP_RESEARCH_ROLES + `/${id}`),

	/**
	 * Updates a list of research-team roles.
	 *
	 * @param {ResearchRole[]} body - The data to update the research-team roles with.
	 *
	 * @returns {Promise<ResearchRole[]>} A Promise that resolves with the updated research-team roles.
	 */
	batchUpdate: body => put(API_SP_RESEARCH_ROLES, body)
};
